import { render, staticRenderFns } from "./integralConfigManageList.vue?vue&type=template&id=74f9ad27&scoped=true"
import script from "./integralConfigManageList.vue?vue&type=script&lang=js"
export * from "./integralConfigManageList.vue?vue&type=script&lang=js"
import style0 from "./integralConfigManageList.vue?vue&type=style&index=0&id=74f9ad27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f9ad27",
  null
  
)

export default component.exports